(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["azafran-weight-selector-pilot"] && !Shopify.designMode) return;
  try {
    (() => {
    function upsertInput(form, property, value) {
      const name = `properties[${property}]`;
      let input = form.querySelector(`input[name="${name}"]`);

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }

      input.value = value;
    }

    function initializeSelector(root) {
      if (root.dataset.initialized === 'true') return;

      const form = document.getElementById(root.dataset.formId);
      const productForm = form?.closest('product-form');
      const submitButton = productForm?.querySelector('[type="submit"]');
      const status = root.querySelector('[data-weight-status]');
      const choices = [...root.querySelectorAll('[data-weight-grams]')];

      if (!form || !submitButton || !status || choices.length === 0) return;

      root.dataset.initialized = 'true';
      submitButton.setAttribute('aria-disabled', 'true');

      choices.forEach((choice) => {
        choice.addEventListener('click', () => {
          const grams = Number(choice.dataset.weightGrams);
          choices.forEach((item) => {
            item.setAttribute('aria-pressed', item === choice ? 'true' : 'false');
          });

          upsertInput(form, 'Peso', `${grams} g`);
          upsertInput(form, '_azafran_weight_engine', 'v1-web');
          upsertInput(form, '_azafran_weight_grams', String(grams));
          upsertInput(form, '_azafran_weight_preset', String(grams));

          status.textContent = `${grams} g`;
          status.dataset.selected = 'true';
          submitButton.removeAttribute('aria-disabled');
        });
      });
    }

    function initializeAll(scope = document) {
      scope.querySelectorAll('[data-azafran-weight-pilot]').forEach(initializeSelector);
    }

    document.addEventListener('DOMContentLoaded', () => initializeAll());
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    initializeAll();
  })();
  } catch(e) { console.error(e); }
})();

})();
